import Vue from 'vue'
import {
  NavBar, Button, Toast, Form, Field, Popup, Area,
  Tab, Tabs, Picker, Cell, Overlay, Cascader, Dialog,
  RadioGroup, Radio, Checkbox, CheckboxGroup, CellGroup,
  Icon, Swipe, SwipeItem
} from 'vant'
import App from './App.vue'
import 'normalize.css/normalize.css'
import '@/utils/flexible'
import router from './router'
import store from './store'

// 测试环境 / 开发环境加载 vconsole 调试工具
if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_MODE === 'test') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line no-new
  new VConsole()
}

Vue.config.productionTip = false
Vue.use(NavBar).use(Button).use(Toast).use(Form)
  .use(Field)
  .use(Popup)
  .use(Area)
  .use(Tab)
  .use(Tabs)
  .use(Picker)
  .use(Cell)
  .use(Overlay)
  .use(Cascader)
  .use(Dialog)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(CellGroup)
  .use(Icon)
  .use(Swipe)
  .use(SwipeItem)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
